interface ButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

const Button = ({ onClick, children, className = "", disabled }: ButtonProps) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`border-[0.23vh] border-fourth-hover h-[51px] md:h-[6vh] bg-[#131313] rounded-[20px] text-[white] flex justify-center items-center ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
  >
    {children}
  </button>
);

export default Button;